import {
  Button,
  Col,
  Form,
  message,
  Row,
  Space,
  Image,
  Typography,
} from "antd";
import React, { useEffect } from "react";
import "./CreateNewPassword.css";
import FloatingInput from "../../../components/common/float-input/FloatInput";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate, useParams } from "react-router-dom";
import { resetPassword } from "../../../store/thunks/authThunk";
import { useDispatch, useSelector } from "react-redux";
import AMPlogo from "../../../assests/ampg-svg.svg";
import AMPlogo_w from "../../../assests/ampw-svg.svg";
import LoginImg from "../../../assests/login-img.png";
const { Text } = Typography;
const CreateNewPassword = ({ navigateTo }) => {
  const navigate = useNavigate();
  const isSmL = useMediaQuery({ maxWidth: 767 });
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { token } = useParams();
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
    "--label-margin-top": "-6px",
  };

  // Get state from Redux store
  const { requestStatus, error, isLoading } = useSelector(
    (state) => state.password
  );

  // Password validation regex
  const passwordRules = [
    { required: true, message: "New Password is required!" },
    {
      pattern:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
      message: "Password must be at least 8 characters long !",
    },
  ];

  useEffect(() => {
    if (requestStatus === "success") {
      message.success("Password Reset Successfully!");
    }
    if (requestStatus === "failed") {
      message.error(error || "Failed to reset password.");
    }
  }, [requestStatus, error, navigateTo]);

  const handleSubmit = (values) => {
    const payload = {
      code: token,
      newPassword: values.NewPassword,
      confirmNewPassword: values.ConfirmPassword,
    };
    dispatch(resetPassword(payload)).then((res) => {
      if (res?.payload?.status === 1) {
        navigate("/login");
      }
    });
  };

  return (
    <div className="login-container">
      <Row style={{ height: "100%" }}>
        {!isMobile ? (
          <Col span={12}>
            <div
              className="login-image"
              style={{
                backgroundImage: `url(${LoginImg})`,
                height: "100%",
                width: "100%",
              }}
            >
              <div className="gradient-layer" />
              <Image
                preview={false}
                src={AMPlogo_w}
                alt="Logo"
                className="logo-overlay"
              />
            </div>
          </Col>
        ) : null}
        <Col xs={24} sm={24} md={12} className="login-form-container">
          {isSmL ? (
            <div className="common-css">
              <Image
                src={AMPlogo}
                alt="amp-logo"
                height={60}
                width={190}
                preview={false}
              />
            </div>
          ) : null}
          <Space
            direction="vertical"
            size={12}
            className="create-new-password-main-space"
          >
            <Row justify="center">
              <Text className="create-password-h">Create a New Password</Text>
            </Row>
            <Row justify="center" style={{ textAlign: "center" }}>
              <Col span={20}>
                <Text className="create-password-sh">
                  Enter a new password below to securely access your account.
                  You’re almost there!
                </Text>
              </Col>
            </Row>

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              className="create-password-form"
            >
              {/* New Password */}
              <Row justify="center">
                <Form.Item
                  name="NewPassword"
                  rules={passwordRules}
                  style={{ width: "90%" }}
                >
                  <FloatingInput
                    className="billboard-input-feild reset-password-fields billboard-password-field"
                    label={<>{`New Password `}</>}
                    isPassword={true}
                    customStyles={floatingInputStyles}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        form.submit();
                      }
                    }}
                  />
                </Form.Item>
              </Row>

              {/* Confirm Password */}
              <Row justify="center">
                <Form.Item
                  name="ConfirmPassword"
                  dependencies={["NewPassword"]}
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your new password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("NewPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match!")
                        );
                      },
                    }),
                  ]}
                  style={{ width: "90%" }}
                >
                  <FloatingInput
                    className="billboard-input-feild billboard-password-field"
                    label={<>{`Confirm Password`}</>}
                    isPassword={true}
                    // width={isSmL ? "22rem" : "28rem"}
                    customStyles={floatingInputStyles}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        form.submit();
                      }
                    }}
                  />
                </Form.Item>
              </Row>

              {/* Password Guidelines */}
              <Row justify="center" className="restrictions-row">
                <div className="validation-container">
                  <ul>
                    <li className="validation-container-text">
                      Use 8+ characters with a mix of uppercase, lowercase,
                      numbers, and symbols.
                    </li>
                    <li className="validation-container-text">
                      Avoid common words or easily guessed phrases.
                    </li>
                    <li className="validation-container-text">
                      Don't reuse old passwords for extra security.
                    </li>
                  </ul>
                </div>
              </Row>

              {/* Submit Button */}
              <Row className="restrictions-row" justify="center">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="reset-new-button billboard-button-2"
                  loading={isLoading}
                >
                  {isLoading ? "Resetting..." : "Reset Password"}
                </Button>
              </Row>
            </Form>

            {/* Back to Login */}
            <Row align="middle" justify="center" style={{ marginTop: 20 }}>
              <Link
                className="forgot-password"
                onClick={() => navigate("/login")}
              >
                Back to Login
              </Link>
            </Row>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default CreateNewPassword;
